import { frontendURL } from 'dashboard/helper/URLHelper';

export default {
  routes: [
    {
      // Um app marcado para a barra lateral abre em tela cheia, sem conversa.
      // `appId` e o id do DashboardApp, nao um slug: o titulo e editavel e uma
      // URL guardada pelo agente deixaria de resolver na primeira renomeacao.
      path: frontendURL('accounts/:accountId/dashboard-apps/:appId'),
      name: 'dashboard_app_view',
      component: () => import('./DashboardAppView.vue'),
      meta: {
        permissions: ['administrator', 'agent'],
      },
    },
  ],
};
